<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  server: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['confirm', 'close']);

const { t } = useI18n();
const dialogRef = ref(null);

const handleConfirm = () => {
  emit('confirm');
};

const handleClose = () => {
  emit('close');
};

onMounted(() => {
  dialogRef.value?.open();
});

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('INTEGRATION_SETTINGS.MCP_SERVERS.DELETE.TITLE')"
    :confirm-button-label="t('INTEGRATION_SETTINGS.MCP_SERVERS.DELETE.CONFIRM')"
    :cancel-button-label="t('INTEGRATION_SETTINGS.MCP_SERVERS.DELETE.CANCEL')"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <div class="space-y-4">
      <p class="text-slate-600 dark:text-slate-400">
        {{ t('INTEGRATION_SETTINGS.MCP_SERVERS.DELETE.MESSAGE') }}
      </p>

      <!-- Server Details -->
      <div
        class="p-3 bg-slate-50 dark:bg-slate-700/50 rounded-lg border border-slate-200 dark:border-slate-600"
      >
        <div class="flex items-center gap-3">
          <div class="min-w-0">
            <p class="font-medium text-slate-900 dark:text-slate-100 truncate">
              {{ server.label }}
            </p>
            <p
              v-if="!server.internal && server.url"
              class="text-sm text-slate-500 dark:text-slate-400 truncate"
            >
              {{ server.url }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>
